import UserNameToAvatarMapper from './UserNameToAvatarMapper';

const RawUserMapper = (rawUsers, rawFeedback) =>
  rawUsers.map(({
    userName,
    email,
    userId,
    displayName,
    avatarImgUrl,
    heroImgUrl,
    avatarMedUrl,
  }) => ({
    userName,
    email,
    userId,
    displayName,
    avatarImgUrl,
    avatarMedUrl,
    heroImgUrl,
    avatar: UserNameToAvatarMapper(userName),
    numberOfRefferingFeedback: rawFeedback.filter(fb => fb.slackUserFeedbackId === userId).length,
    thumbsUp: rawFeedback.filter(fb =>
      fb.slackUserFeedbackId === userId && fb.feedbackKind === 'positive').length,
    thumbsDown: rawFeedback.filter(fb =>
      fb.slackUserFeedbackId === userId && fb.feedbackKind === 'negative').length,
    numberOfSubmittedFeedback: rawFeedback.filter(fb => fb.slackUserId === userId).length,
    numberOfNeutralFeedback:
        rawFeedback.filter(fb => fb.slackUserFeedbackId === userId).length -
        rawFeedback.filter(fb =>
          fb.slackUserFeedbackId === userId && fb.feedbackKind === 'negative').length -
        rawFeedback.filter(fb =>
          fb.slackUserFeedbackId === userId && fb.feedbackKind === 'positive').length,
  }));

export default RawUserMapper;



// WEBPACK FOOTER //
// ./src/utils/mappers/RawUserMapper.js